import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

type CreateUserV2Payload = {
  function: string;
  name: string;
  cpf: string;
  email: string;
  mobile?: string;
  birthdate?: string;
};

@Injectable({
  providedIn: 'root',
})
export class UsersV2Service {
  private readonly url = `${environment.api_v2}/v2/user`;

  constructor(private readonly http: HttpClient) {}

  private mapFunction(label: string): string {
    const v = (label || '').toLowerCase();
    if (v.startsWith('admin')) return 'Administrador';
    if (v.startsWith('assist')) return 'Assistente';
    return 'Assistente';
  }

  createUser(body: any): Observable<void> {
    const payload: CreateUserV2Payload = {
      function: this.mapFunction(body.function),
      name: body.name,
      cpf: body.cpf,
      email: body.email,
      mobile: body.mobile,
      birthdate: body.birthdate,
    };
    return this.http.post<void>(this.url, payload);
  }
}